<template>
  <div class="service-area-container w-full flex flex-col justify-center items-center font-rubik bg-themeComponentBg-light">
    <div class="flex flex-col w-full max-w-1216">
      <div class="flex flex-wrap justify-between gap-4 w-full">
        <!-- Container Sales -->
        <a
          v-if="getSolutionByLinkType('sales')"
          :href="linkPath('sales')"
          class="card-wrapper"
        >
          <div class="service-area-cards card-sales">
            <div class="image-container">
              <img class="primary-image" src="@/images/service-area-cards/container-sales.png" alt="Container Sales">
              <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-sales.svg" alt="Container Sales">
            </div>
            <div class="flex flex-col gap-2">
              <h3>Container Sales</h3>
              <div v-html="getSolutionByLinkType('sales').html_content" class="card-description"></div>
            </div>
            <div class="flex justify-start items-center">
              <span>Learn more</span>
              <div class="arrow-container">
                <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
                <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-sales.png" alt="Arrow">
              </div>
            </div>
          </div>
        </a>

        <!-- Container Rentals -->
        <a
          v-if="getSolutionByLinkType('rentals')"
          :href="linkPath('rentals')"
          class="card-wrapper"
        >
          <div class="service-area-cards card-rentals">
            <div class="image-container">
              <img class="primary-image" src="@/images/service-area-cards/container-rentals.png" alt="Container Rentals">
              <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-rentals.svg" alt="Container Rentals">
            </div>
            <div class="flex flex-col gap-2">
              <h3>Container Rentals</h3>
              <div v-html="getSolutionByLinkType('rentals').html_content" class="card-description"></div>
            </div>
            <div class="flex justify-start items-center">
              <span>Learn more</span>
              <div class="arrow-container">
                <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
                <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-rentals.png" alt="Arrow">
              </div>
            </div>
          </div>
        </a>

        <!-- Refrigerated Containers -->
        <a
          v-if="getSolutionByLinkType('refrigerated')"
          :href="linkPath('refrigerated')"
          class="card-wrapper"
        >
          <div class="service-area-cards card-refrigerated">
            <div class="image-container">
              <img class="primary-image" src="@/images/service-area-cards/refrigerated-containers.png" alt="Refrigerated Containers">
              <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-conditioning.svg" alt="Refrigerated Containers">
            </div>
            <div class="flex flex-col gap-2">
              <h3>Refrigerated Containers</h3>
              <div v-html="getSolutionByLinkType('refrigerated').html_content" class="card-description"></div>
            </div>
            <div class="flex justify-start items-center">
              <span>Learn more</span>
              <div class="arrow-container">
                <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
                <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/refrigerated-containers.png" alt="Arrow">
              </div>
            </div>
          </div>
        </a>

        <!-- Portable Offices -->
        <a
          v-if="getSolutionByLinkType('portable')"
          :href="linkPath('portable')"
          class="card-wrapper"
        >
          <div class="service-area-cards card-portable-offices">
            <div class="image-container">
              <img class="primary-image" src="@/images/service-area-cards/portable-offices.png" alt="Portable Offices">
              <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-portable-offices.svg" alt="Portable Offices">
            </div>
            <div class="flex flex-col gap-2">
              <h3>Portable Offices</h3>
              <div v-html="getSolutionByLinkType('portable').html_content" class="card-description"></div>
            </div>
            <div class="flex justify-start items-center">
              <span>Learn more</span>
              <div class="arrow-container">
                <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
                <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/portable-offices.png" alt="Arrow">
              </div>
            </div>
          </div>
        </a>

        <!-- Container Modifications -->
        <a
          v-if="getSolutionByLinkType('modifications')"
          :href="linkPath('modifications')"
          class="card-wrapper"
        >
          <div class="service-area-cards card-modifications">
            <div class="image-container">
              <img class="primary-image" src="@/images/service-area-cards/container-modifications.png" alt="Container Modifications">
              <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-modifications.svg" alt="Container Modifications">
            </div>
            <div class="flex flex-col gap-2">
              <h3>Container Modifications</h3>
              <div v-html="getSolutionByLinkType('modifications').html_content" class="card-description"></div>
            </div>
            <div class="flex justify-start items-center">
              <span>Learn more</span>
              <div class="arrow-container">
                <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
                <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-modifications.png" alt="Arrow">
              </div>
            </div>
          </div>
        </a>

        <!-- Refrigerated Container Rentals -->
        <a
          v-if="getSolutionByLinkType('refrigerated-container-rentals')"
          :href="linkPath('refrigerated-container-rentals')"
          class="card-wrapper"
        >
          <div class="service-area-cards card-refrigerated-rentals">
            <div class="image-container">
              <img class="primary-image" src="@/images/service-area-cards/refrigerated-containers.png" alt="Refrigerated Container Rentals">
              <img class="hover-image" src="@/images/service-area-cards/hover-state/hover-conditioning.svg" alt="Refrigerated Container Rentals">
            </div>
            <div class="flex flex-col gap-2">
              <h3>Refrigerated Container Rentals</h3>
              <div v-html="getSolutionByLinkType('refrigerated-container-rentals').html_content" class="card-description"></div>
            </div>
            <div class="flex justify-start items-center">
              <span>Learn more</span>
              <div class="arrow-container">
                <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
                <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/refrigerated-containers.png" alt="Arrow">
              </div>
            </div>
          </div>
        </a>

        <!-- CA Accessories -->
        <a
          v-if="getSolutionByLinkType('accessories')"
          :href="linkPath('accessories')"
          class="card-wrapper"
        >
          <div class="service-area-cards card-accessories">
            <div class="image-container">
              <img class="primary-image" src="@/images/service-area-cards/container-accessories.png" alt="Container Accessories">
              <img class="hover-image" src="@/images/service-area-cards/tags/container-accessories.png" alt="Container Accessories">
            </div>
            <div class="flex flex-col gap-2">
              <h3>Container Accessories</h3>
              <div v-html="getSolutionByLinkType('accessories').html_content" class="card-description"></div>
            </div>
            <div class="flex justify-start items-center">
              <span>Learn more</span>
              <div class="arrow-container">
                <img class="default-arrow" src="@/images/service-area-cards/Arrow.png" alt="Arrow">
                <img class="hover-arrow" src="@/images/service-area-cards/forward-arrows/container-accessories.png" alt="Arrow">
              </div>
            </div>
          </div>
        </a>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      required: false,
      type: String
    },
    solutions: {
      required: true,
      type: Array
    },
    solutionsPath: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      solutionsArr: [],
      keywordMappings: [
        { keyword: 'refrigerated container rentals', output: 'Refrigerated Container Rentals' },
        { keyword: 'refrigerated containers', output: 'Refrigerated Containers' },
        { keyword: 'container modifications', output: 'Container Modifications' },
        { keyword: 'portable offices', output: 'Portable Offices' },
        { keyword: 'accessories', output: 'Container Accessories' },
        { keyword: 'container sales', output: 'Container Sales' },
        { keyword: 'sales', output: 'Container Sales' },
        { keyword: 'rentals', output: 'Container Rentals' },
        { keyword: 'modifications', output: 'Container Modifications' },
        { keyword: 'portable', output: 'Portable Offices' },
        { keyword: 'refrigerated', output: 'Refrigerated Containers' }
      ]
    }
  },
  computed: {
    currentUrl() {
      return window.location.pathname
    }
  },
  created() {
    this.createSolutionsArray(this.solutions)
  },
  methods: {
    truncateText(content, charCount) {
      const sanitizedContent = content.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim()
      return sanitizedContent.length > charCount
        ? sanitizedContent.substring(0, charCount) + '...'
        : sanitizedContent
    },
    createSolutionsArray(solutions) {
      this.solutionsArr = solutions.map(solution => {
        const formattedTitle = this.formatTitle(solution.title)
        const slug = this.getSolutionSlug(solution.id)

        return {
          title: formattedTitle,
          slug: slug,
          id: solution.id,
          html_content: solution.html_content || solution.description || ''
        }
      })
    },
    formatTitle(title) {
      const lowerTitle = title.toLowerCase()
      for (const mapping of this.keywordMappings) {
        if (lowerTitle.includes(mapping.keyword.toLowerCase())) {
          return mapping.output
        }
      }
      return title.replace(/\b\w/g, l => l.toUpperCase())
    },
    getSolutionSlug(id) {
      return this.solutionsPath[id.toString()] || '#'
    },
    getSolutionByLinkType(linkType) {
      const mapping = {
        'sales': 'container sales',
        'rentals': 'container rentals',
        'modifications': 'container modifications',
        'refrigerated': 'refrigerated containers',
        'portable': 'portable offices',
        'refrigerated-container-rentals': 'refrigerated container rentals',
        'accessories': 'container accessories'
      }
      const keyword = mapping[linkType]
      return this.solutionsArr.find(s => s.title.toLowerCase().includes(keyword))
    },
    linkPath(linkType) {
      const solution = this.getSolutionByLinkType(linkType)
      return solution ? solution.slug : '#'
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  color: black !important;
}

.service-area-container {
  padding: 0;
}

.service-area-container .flex {
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
}

.card-wrapper {
  flex: 1 1 calc(33.333% - 16px);
  max-width: 394.67px;
  width: 100%;
  box-sizing: border-box;
}

.service-area-cards {
  background-color: white;
  border-radius: 16px;
  border: 1px solid #E2E1DE;
  width: 100%;
  height: 303px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
}

.service-area-cards.card-sales:hover {
  background-color: #eef4ff;
}

.service-area-cards.card-sales:hover span {
  color: #1F44F1;
}

.service-area-cards.card-rentals:hover {
  background-color: #ECFEFF;
}

.service-area-cards.card-rentals:hover span {
  color: #0891B2;
}

.service-area-cards.card-refrigerated:hover {
  background-color: #EFFDFA;
}

.service-area-cards.card-refrigerated:hover span {
  color: #0D9488;
}

.service-area-cards.card-portable-offices:hover {
  background-color: #F7FEE7;
}

.service-area-cards.card-portable-offices:hover span {
  color: #65A30D;
}

.service-area-cards.card-modifications:hover {
  background-color: #EFF6FF;
}

.service-area-cards.card-modifications:hover span {
  color: #DC2626;
}

.service-area-cards.card-accessories:hover {
  background-color: #FEF9C3;
}

.service-area-cards.card-accessories:hover span {
  color: #CA8A04;
}

.service-area-cards.card-refrigerated-rentals:hover {
  background-color: #EFFDFA;
}

.service-area-cards.card-refrigerated-rentals:hover span {
  color: #0D9488;
}

.service-area-cards h3 {
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: black;
}

.card-description {
  max-height: 120px;
  overflow-y: auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #666666 !important;
   /* Custom scrollbar styling for WebKit-based browsers */
  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #C1C1C1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #7D7D7D;
  }
}

.service-area-cards span {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.0125em;
  color: black;
}

/* Mobile styles */
@media (max-width: 1024px) {
  .service-area-container {
    padding: 20px;
  }

  .card-wrapper {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .service-area-cards {
    height: 307px;
  }
}

/* Image Hover Effects */
.image-container {
  position: relative;
}

.image-container .primary-image {
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.image-container .hover-image {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transform: translate(10px, 10px) scale(0.95);
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.card-wrapper:hover .primary-image {
  opacity: 0;
}

.card-wrapper:hover .hover-image {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

/* Arrow Hover Effects */
.arrow-container {
  position: relative;
  width: 24px;
  height: 24px;
  margin-left: 8px;
}

.arrow-container .default-arrow {
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.arrow-container .hover-arrow {
  position: absolute;
  top: 5px;
  left: 2px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.card-wrapper:hover .arrow-container .default-arrow {
  opacity: 0;
}

.card-wrapper:hover .arrow-container .hover-arrow {
  opacity: 1;
}
</style>
